import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Icon from "@material-ui/core/Icon";
import injectSheet from "../../../_common/hocs/injectSheet/injectSheet";

const styles = {
  icone: {
    fontSize: 21,
  },
  iconePreenchido: {
    color: "gold !important",
  },
  iconeVazio: {
    backgroundColor: "transparent !important",
  },
};

class ScoreDeSimilaridade extends React.PureComponent {
  render() {
    return Array.from(Array(5).keys()).map((item, index) => {
      const preencheScore = this.props.score >= index + 1;
      return (
        <Icon
          key={index}
          className={cn(
            this.props.classes.icone,
            preencheScore ? this.props.classes.iconePreenchido : this.props.classes.iconeVazio
          )}
        >
          {preencheScore ? "star" : "star_border"}
        </Icon>
      );
    });
  }
}

ScoreDeSimilaridade.propTypes = {
  /** Valor do score de similaridade */
  score: PropTypes.number,
  /** @ignore */
  classes: PropTypes.object,
};

export default injectSheet(styles)(ScoreDeSimilaridade);
